import './progress.scss';

import Progress from './Progress';

export default Progress;
